import { Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslate } from "../components/Translate/TranslateContext";
import AccountCard from "../components/Layout/AccountCard";

export default function SignupCard() {
  const { translate } = useTranslate();
  const navigate = useNavigate();

  return (
    <AccountCard edge="right" title={translate("create_account")}>
      <Typography
        sx={{
          mt: 2,
          mb: 3,
          color: "text.secondary",
          textAlign: "center",
        }}
      >
        {translate("signup_cta_description")}
      </Typography>

      <Button
        variant="contained"
        fullWidth
        size="large"
        onClick={() => navigate("/register")}
      >
        {translate("get_started")}
      </Button>
    </AccountCard>
  );
}
